/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import styles from './MotiliButtonContainer.module.scss';

export default class MotiliButtonContainer extends PureComponent {
    render() {
        return (
            <div
                className={styles.motiliButtonContainer}
                style={{ ...this.props.styles }}
            >
                {this.props.children}
            </div>
        );
    }
}

MotiliButtonContainer.propTypes = {
    children: PropTypes.node,
    styles: PropTypes.shape({}),
};
